import Feeds from './Feeds/Feeds';
import HomeEvents from './HomeEvents/HomeEvents';
import { useHome } from './useHome';
import { useEffect } from 'react';
import { setPageTitle } from '../../utils/helpers';
import { useTranslation } from '../../hooks/translations/TranslationProvider';

import './home.css';

const Home = () => {
    const { t } = useTranslation();

    const {
        feedsLoading,
        feeds,
        feedsError,
        showLoadMoreFeedsButton,
        onShowMoreFeedsClick,
        userEvents,
        userEventsError,
        userEventsLoading,
    } = useHome();

    useEffect(() => {
        setPageTitle(t('seo.home.title'));
    }, [t]);

    return (
        <div className="home page-container">
            {/* {userEvents.nextEvents.length > 0 && (
                <HomeEvents
                    userEvents={userEvents}
                    isLoading={userEventsLoading}
                    error={userEventsError}
                />
            )} */}

            <Feeds
                feeds={feeds}
                isLoading={feedsLoading}
                error={feedsError}
                showLoadMoreFeedsButton={showLoadMoreFeedsButton}
                onShowMoreFeedsClick={onShowMoreFeedsClick}
            />
        </div>
    );
};

export default Home;
